/**
 * Checks a given password against the following requirements:
 * - At least 12 characters long
 * - Contains at least one lowercase letter
 * - Contains at least one uppercase letter
 * - Contains at least one number
 * - Contains at least one special character
 *
 * @param password The password to check
 * @returns An object with boolean properties indicating whether each requirement was met
 */
export const checkPasswordRequirements = (password: string) => {
  const passwordRequirements = {
    length: password.length >= 12,
    lowercase: /[a-z]/.test(password),
    uppercase: /[A-Z]/.test(password),
    number: /\d/.test(password),
    special: /[!@#$%^&*(),.?":{}|<>]/.test(password),
  };

  return passwordRequirements;
};
